// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DevelopmentCommitmentLineItemsQueryVariables = Types.Exact<{
  developmentCommitmentId: Types.Scalars['ID']['input'];
}>;


export type DevelopmentCommitmentLineItemsQuery = { __typename?: 'Query', developmentCommitment: { __typename?: 'DevelopmentCommitment', id: string, canBeEdited: boolean, committedInCents: number, stage: Types.Stage, status: Types.CommitmentStatus, commitments: Array<{ __typename?: 'Commitment', id: string, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, billedInCents?: number | null | undefined, unbilledInCents: number, committedInCents: number, paidInCents?: number | null | undefined, balanceInCents?: number | null | undefined, quantity?: number | null | undefined, costCode: { __typename?: 'CostCode', id: string, displayName: string }, projectItem: { __typename?: 'ProjectItem', id: string, name: string, costType: Types.CostType, item: { __typename?: 'Item', id: string, isSelection: boolean, fullCode: string }, homeownerSelection?: { __typename?: 'HomeownerSelection', id: string, status: { __typename?: 'HomeownerSelectionStatusDetail', code: Types.HomeownerSelectionStatus } } | null | undefined, location: { __typename?: 'Location', id: string, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, project: { __typename?: 'StandaloneProject', name: string, id: string } | { __typename?: 'Region', name: string, id: string } | { __typename?: 'Market', name: string, id: string } | { __typename?: 'Community', name: string, id: string } | { __typename?: 'Subdivision', name: string, id: string } | { __typename?: 'Lot', name: string, id: string } | { __typename?: 'Structure', name: string, id: string } | { __typename?: 'Unit', name: string, id: string } } }> }>, projects: Array<{ __typename?: 'StandaloneProject', id: string } | { __typename?: 'Region', id: string } | { __typename?: 'Market', id: string } | { __typename?: 'Community', id: string } | { __typename?: 'Subdivision', id: string } | { __typename?: 'Lot', id: string } | { __typename?: 'Structure', id: string } | { __typename?: 'Unit', id: string }> } };

export type DcLineItemsTabCommitmentLineItemFragment = { __typename?: 'CommitmentLineItem', id: string, billedInCents?: number | null | undefined, unbilledInCents: number, committedInCents: number, paidInCents?: number | null | undefined, balanceInCents?: number | null | undefined, quantity?: number | null | undefined, costCode: { __typename?: 'CostCode', id: string, displayName: string }, projectItem: { __typename?: 'ProjectItem', id: string, name: string, costType: Types.CostType, item: { __typename?: 'Item', id: string, isSelection: boolean, fullCode: string }, homeownerSelection?: { __typename?: 'HomeownerSelection', id: string, status: { __typename?: 'HomeownerSelectionStatusDetail', code: Types.HomeownerSelectionStatus } } | null | undefined, location: { __typename?: 'Location', id: string, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, project: { __typename?: 'StandaloneProject', name: string, id: string } | { __typename?: 'Region', name: string, id: string } | { __typename?: 'Market', name: string, id: string } | { __typename?: 'Community', name: string, id: string } | { __typename?: 'Subdivision', name: string, id: string } | { __typename?: 'Lot', name: string, id: string } | { __typename?: 'Structure', name: string, id: string } | { __typename?: 'Unit', name: string, id: string } } };

export type DeleteCommitmentLineItemsMutationVariables = Types.Exact<{
  input: Types.DeleteCommitmentLineItemsInput;
}>;


export type DeleteCommitmentLineItemsMutation = { __typename?: 'Mutation', deleteCommitmentLineItems: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type SaveCommitmentLineItemsMutationVariables = Types.Exact<{
  input: Types.SaveCommitmentInput;
}>;


export type SaveCommitmentLineItemsMutation = { __typename?: 'Mutation', saveCommitment: { __typename?: 'SaveCommitmentResult', commitment: { __typename?: 'Commitment', id: string, lineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, billedInCents?: number | null | undefined, unbilledInCents: number, committedInCents: number, paidInCents?: number | null | undefined, balanceInCents?: number | null | undefined, quantity?: number | null | undefined, costCode: { __typename?: 'CostCode', id: string, displayName: string }, projectItem: { __typename?: 'ProjectItem', id: string, name: string, costType: Types.CostType, item: { __typename?: 'Item', id: string, isSelection: boolean, fullCode: string }, homeownerSelection?: { __typename?: 'HomeownerSelection', id: string, status: { __typename?: 'HomeownerSelectionStatusDetail', code: Types.HomeownerSelectionStatus } } | null | undefined, location: { __typename?: 'Location', id: string, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, name: string }, project: { __typename?: 'StandaloneProject', name: string, id: string } | { __typename?: 'Region', name: string, id: string } | { __typename?: 'Market', name: string, id: string } | { __typename?: 'Community', name: string, id: string } | { __typename?: 'Subdivision', name: string, id: string } | { __typename?: 'Lot', name: string, id: string } | { __typename?: 'Structure', name: string, id: string } | { __typename?: 'Unit', name: string, id: string } } }> } } };

export const DcLineItemsTabCommitmentLineItemFragmentDoc = gql`
    fragment DcLineItemsTabCommitmentLineItem on CommitmentLineItem {
  id
  costCode {
    id
    displayName
  }
  billedInCents
  unbilledInCents
  committedInCents
  paidInCents
  balanceInCents
  quantity
  projectItem {
    id
    name
    costType
    item {
      id
      isSelection
      fullCode
    }
    homeownerSelection {
      id
      status {
        code
      }
    }
    location {
      id
      name
    }
    unitOfMeasure {
      id
      name
    }
    project {
      name
      id
    }
  }
}
    `;
export const DevelopmentCommitmentLineItemsDocument = gql`
    query DevelopmentCommitmentLineItems($developmentCommitmentId: ID!) {
  developmentCommitment(id: $developmentCommitmentId) {
    id
    canBeEdited
    commitments {
      id
      lineItems {
        ...DcLineItemsTabCommitmentLineItem
      }
    }
    projects {
      id
    }
    committedInCents
    stage
    status
  }
}
    ${DcLineItemsTabCommitmentLineItemFragmentDoc}`;

/**
 * __useDevelopmentCommitmentLineItemsQuery__
 *
 * To run a query within a React component, call `useDevelopmentCommitmentLineItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentCommitmentLineItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentCommitmentLineItemsQuery({
 *   variables: {
 *      developmentCommitmentId: // value for 'developmentCommitmentId'
 *   },
 * });
 */
export function useDevelopmentCommitmentLineItemsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DevelopmentCommitmentLineItemsQuery, DevelopmentCommitmentLineItemsQueryVariables> & ({ variables: DevelopmentCommitmentLineItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevelopmentCommitmentLineItemsQuery, DevelopmentCommitmentLineItemsQueryVariables>(DevelopmentCommitmentLineItemsDocument, options);
      }
export function useDevelopmentCommitmentLineItemsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevelopmentCommitmentLineItemsQuery, DevelopmentCommitmentLineItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevelopmentCommitmentLineItemsQuery, DevelopmentCommitmentLineItemsQueryVariables>(DevelopmentCommitmentLineItemsDocument, options);
        }
export function useDevelopmentCommitmentLineItemsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentCommitmentLineItemsQuery, DevelopmentCommitmentLineItemsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DevelopmentCommitmentLineItemsQuery, DevelopmentCommitmentLineItemsQueryVariables>(DevelopmentCommitmentLineItemsDocument, options);
        }
export type DevelopmentCommitmentLineItemsQueryHookResult = ReturnType<typeof useDevelopmentCommitmentLineItemsQuery>;
export type DevelopmentCommitmentLineItemsLazyQueryHookResult = ReturnType<typeof useDevelopmentCommitmentLineItemsLazyQuery>;
export type DevelopmentCommitmentLineItemsSuspenseQueryHookResult = ReturnType<typeof useDevelopmentCommitmentLineItemsSuspenseQuery>;
export type DevelopmentCommitmentLineItemsQueryResult = Apollo.QueryResult<DevelopmentCommitmentLineItemsQuery, DevelopmentCommitmentLineItemsQueryVariables>;
export const DeleteCommitmentLineItemsDocument = gql`
    mutation DeleteCommitmentLineItems($input: DeleteCommitmentLineItemsInput!) {
  deleteCommitmentLineItems(input: $input) {
    emptyResult
  }
}
    `;
export type DeleteCommitmentLineItemsMutationFn = Apollo.MutationFunction<DeleteCommitmentLineItemsMutation, DeleteCommitmentLineItemsMutationVariables>;

/**
 * __useDeleteCommitmentLineItemsMutation__
 *
 * To run a mutation, you first call `useDeleteCommitmentLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommitmentLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommitmentLineItemsMutation, { data, loading, error }] = useDeleteCommitmentLineItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCommitmentLineItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCommitmentLineItemsMutation, DeleteCommitmentLineItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCommitmentLineItemsMutation, DeleteCommitmentLineItemsMutationVariables>(DeleteCommitmentLineItemsDocument, options);
      }
export type DeleteCommitmentLineItemsMutationHookResult = ReturnType<typeof useDeleteCommitmentLineItemsMutation>;
export type DeleteCommitmentLineItemsMutationResult = Apollo.MutationResult<DeleteCommitmentLineItemsMutation>;
export type DeleteCommitmentLineItemsMutationOptions = Apollo.BaseMutationOptions<DeleteCommitmentLineItemsMutation, DeleteCommitmentLineItemsMutationVariables>;
export const SaveCommitmentLineItemsDocument = gql`
    mutation SaveCommitmentLineItems($input: SaveCommitmentInput!) {
  saveCommitment(input: $input) {
    commitment {
      id
      lineItems {
        ...DcLineItemsTabCommitmentLineItem
      }
    }
  }
}
    ${DcLineItemsTabCommitmentLineItemFragmentDoc}`;
export type SaveCommitmentLineItemsMutationFn = Apollo.MutationFunction<SaveCommitmentLineItemsMutation, SaveCommitmentLineItemsMutationVariables>;

/**
 * __useSaveCommitmentLineItemsMutation__
 *
 * To run a mutation, you first call `useSaveCommitmentLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCommitmentLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCommitmentLineItemsMutation, { data, loading, error }] = useSaveCommitmentLineItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCommitmentLineItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveCommitmentLineItemsMutation, SaveCommitmentLineItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveCommitmentLineItemsMutation, SaveCommitmentLineItemsMutationVariables>(SaveCommitmentLineItemsDocument, options);
      }
export type SaveCommitmentLineItemsMutationHookResult = ReturnType<typeof useSaveCommitmentLineItemsMutation>;
export type SaveCommitmentLineItemsMutationResult = Apollo.MutationResult<SaveCommitmentLineItemsMutation>;
export type SaveCommitmentLineItemsMutationOptions = Apollo.BaseMutationOptions<SaveCommitmentLineItemsMutation, SaveCommitmentLineItemsMutationVariables>;